import { gql } from 'apollo-angular';

export default gql`
  query fieldsOverlay($spaceUri: String!) {
    fieldsOverlay(spaceUri: $spaceUri) {
      __typename
      uri
      name
      tenantUri
      fieldTypeUri
      version
      createdOn
      createdByUri
      updatedOn
      updatedByUri
      propertyValues {
        fieldUri
        fieldTypePropertyUri
        value
      }
      originType
    }
  }
`;
